/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Megamenu
(function(){
    // merge 1st & 2nd subnav
    var $megamenuInners = document.querySelectorAll('.MegaMenu .MegaMenu__Inner');
    $megamenuInners.forEach(function($megamenuInner) {
        var $cols = $megamenuInner.querySelectorAll('.MegaMenu__Item');
        if ($cols.length >= 3) {
            console.log($cols[0]);
            console.log($cols[1]);
    
            let col2Title = $cols[1].querySelector('.MegaMenu__Title');
            let col2List = $cols[1].querySelector('.Linklist');
    
            if (col2Title && col2List) {
                $cols[0].appendChild(col2Title);
                $cols[0].appendChild(col2List);
                
                $megamenuInner.removeChild($cols[1]);
            }
        }    
    });

    // color swatches & sale
    var headerElement = document.querySelector('.Header');
    if (headerElement) {
        let colorSwatches = headerElement.getAttribute('data-color-swatches');
        let data = JSON.parse(colorSwatches);      

        // cleanup
        // data.forEach(function(color) {
        //     color = color.replace(/\n/g, '');
        // });        
        data = data.map((color)=> color.replace(/\n/g, '') );
        let colors = {};
        data.forEach(function(color) {
            var colorData = color.split(':');
            colors[colorData[0]] = colorData[1];
        });

        // console.log('DEBUG: color swatches', data);
        // console.log('DEBUG: color swatches obj', colors);

        let $links = document.querySelectorAll('.MegaMenu .Linklist .Link');
        // console.log('DEBUG: links', $links);
        $links.forEach(function($link) {
            let text = $link.textContent.trim();
            // console.log('DEBUG: text', text);

            for (var propertyName in colors) {
                if (colors.hasOwnProperty(propertyName)) {
                    // console.log(propertyName + ': ' + colors[propertyName]);

                    if (text === propertyName) {
                        // add color icon
                        let spanElement = document.createElement('span');
                        spanElement.className = 'Link__Color';
                        spanElement.style.backgroundColor = colors[propertyName];
                        spanElement.setAttribute('data-color-name', propertyName);

                        $link.appendChild(spanElement);
                        $link.classList.add('Link--color');                                    
                        break;   
                    }
                }
            }            

            if (text.indexOf('Sale') > -1) {
                $link.classList.add('Link--sale');
            }

        });
      }

    // sale in 1st level menu
    let fLinks = document.querySelectorAll('.Header__MainNav .HorizontalList__Item > a');
    if (fLinks && fLinks.length) {
        fLinks.forEach(function(fLink) {
            let text = fLink.textContent.trim();
            if (text.indexOf('Sale') > -1) {
                fLink.classList.add('Link--sale');
            }
        });
    }
    // sale in sidebar menu
    let sLinks = document.querySelectorAll('.SidebarMenu__Nav .Link');
    if (sLinks && sLinks.length) {
        sLinks.forEach(function(sLink) {
            let text = sLink.textContent.trim();
            if (text.indexOf('Sale') > -1) {
                sLink.classList.add('Link--sale');
            }
        });
    }
}());


